/**
 * Created : vincent
 * Date : 2018/5/11  1:24 PM
 * Email : wangxiao@wafersystems.com
 */
import React from 'react';
import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';

class CustomChart extends React.Component {
  getDay(date) {
    const temp = date.split('-');
    let day = temp[temp.length - 1];
    if (day.indexOf('0') === 0) {
      day = day.replace('0', '');
    }
    return day;
  }

  render() {
    const { value, label, data, locals } = this.props;
    const values = data.map(v => v[value]);
    const max = Math.max.apply(null, values);
    return (
      <div className="custom_chart">
        <Row className="row">
          {data.map((v, i) => {
            const height = v[value] === 0 ? 0 : (v[value] / max) * 60;
            return (
              <Col className="col" span={3} key={i}>
                <div className="item">
                  <div className="value">{v[value]}</div>
                  <div className="column_div">
                    <div className="column" style={{ height: height }} />
                  </div>
                  <div className="label" title={v[label]}>
                    {this.getDay(v[label])}
                    {locals === 'en_US' ? (
                      ''
                    ) : (
                      <FormattedMessage id="time_type_day" />
                    )}
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
}

export default CustomChart;



// WEBPACK FOOTER //
// ./src/components/monitor/CustomChart.js